var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevendedor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C4.75315 19 0.5 14.7469 0.5 9.5C0.5 4.25315 4.75315 0 10 0C15.2469 0 19.5 4.25315 19.5 9.5C19.5 14.7469 15.2469 19 10 19ZM6.675 11.4V13.3H9.05V15.2H10.95V13.3H11.9C12.5299 13.3 13.134 13.0498 13.5794 12.6044C14.0248 12.159 14.275 11.5549 14.275 10.925C14.275 10.2951 14.0248 9.69102 13.5794 9.24562C13.134 8.80022 12.5299 8.55 11.9 8.55H8.1C7.97402 8.55 7.8532 8.49996 7.76412 8.41088C7.67504 8.3218 7.625 8.20098 7.625 8.075C7.625 7.94902 7.67504 7.8282 7.76412 7.73912C7.8532 7.65004 7.97402 7.6 8.1 7.6H13.325V5.7H10.95V3.8H9.05V5.7H8.1C7.47011 5.7 6.86602 5.95022 6.42062 6.39562C5.97522 6.84102 5.725 7.44511 5.725 8.075C5.725 8.70489 5.97522 9.30898 6.42062 9.75438C6.86602 10.1998 7.47011 10.45 8.1 10.45H11.9C12.026 10.45 12.1468 10.5 12.2359 10.5891C12.325 10.6782 12.375 10.799 12.375 10.925C12.375 11.051 12.325 11.1718 12.2359 11.2609C12.1468 11.35 12.026 11.4 11.9 11.4H6.675Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevendedor);
export default __webpack_public_path__ + "static/media/Revendedor.638314f8876800c999c22157919772a6.svg";
export { ForwardRef as ReactComponent };